import { createSlice } from "infrastructure/store/lib";
import { sliceMixin } from "infrastructure/store/reducers";
import initialState, { sliceToken } from "./state";
import { deleteApplicationThunk, getApplicationsThunk, putApplicationThunk } from "./thunks";
import type { OnboardingState } from "./types";
import {
    applicationsRequestFulfilled,
    applicationsRequestLoading,
    applicationsRequestRejected,
    deleteApplicationRequestFulfilled,
    updateApplicationRequestFulfilled
} from "./reducers";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: {
        ...sliceMixin<OnboardingState>(initialState),
    },
    extraReducers: builder => {
        builder
            // Get Applications
            .addCase(getApplicationsThunk.pending, applicationsRequestLoading)
            .addCase(getApplicationsThunk.fulfilled, applicationsRequestFulfilled)
            .addCase(getApplicationsThunk.rejected, applicationsRequestRejected)
            // Update Application
            .addCase(putApplicationThunk.pending, applicationsRequestLoading)
            .addCase(putApplicationThunk.fulfilled, updateApplicationRequestFulfilled)
            .addCase(putApplicationThunk.rejected, applicationsRequestRejected)
            // Delete Application
            .addCase(deleteApplicationThunk.pending, applicationsRequestLoading)
            .addCase(deleteApplicationThunk.fulfilled, deleteApplicationRequestFulfilled)
            .addCase(deleteApplicationThunk.rejected, applicationsRequestRejected);
    }
});

export const {
    name,
    actions: {
        changeExportLoading,
        resetState
    }
} = slice;

export default slice.reducer;
